import camelize from 'camelize';
import { compose, lifecycle, mapProps, withStateHandlers } from 'recompose';
import config from '../../../config';
import { withSpinnerWhileLoading } from '../Spinner';
import { isLoggedIn } from '../../Auth/TokenManager';

const userStatus = isLoggedIn() ? 'logged_in' : 'logged_out';
export const getHomepageData = platform => $.get(`${config.localeApi}/page_layout/${platform}/landing_page/${userStatus}`);
export const withHomepageData = platform => compose(
  withStateHandlers({
    errorMessage: null,
    loading: true,
    homepageContent: {},
  }, {
    handleAsyncDone: () => data => ({
      loading: false,
      homepageContent: data
    }),
    handleAsyncFailed: () => () => ({
      loading: false,
      homepageContent: [],
      errorMessage: 'fail fetch homepage API'
    }),
  }),
  lifecycle({
    componentDidMount() {
      const {
        handleAsyncDone,
        handleAsyncFailed
      } = this.props;

      getHomepageData(platform)
        .done(({ data }) => handleAsyncDone(data))
        .fail(() => handleAsyncFailed());
    }
  }),
  withSpinnerWhileLoading,
  mapProps(({ homepageContent, ...props }) => ({
    homepageContent: camelize(homepageContent),
    ...props
  })),
);



// WEBPACK FOOTER //
// ./src/Common/Providers/HomepageApi.js